module.exports = __webpack_public_path__ + "img/file.79aad1ca.svg";